export enum HistoryTimelineStatus { 
  Complete = 'Complete',
  Current = 'Current',
  Upcoming = 'Upcoming',
}